/**
 * Formatters for Fixed Fees module
 * Reusable formatting functions using constants for consistent display
 */

import { EMPTY_VALUE, STATUS_MAP, BILLED_STATUS_MAP, CHARGE_TYPE_MAP, STATUS_COLORS, COMPLETION_COLORS, PROFITABILITY_THRESHOLDS, PROFITABILITY_COLORS } from './constants';

/**
 * Capitalize first letter of string
 */
const capitalize = str => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Format completion status for display
 */
export const formatStatus = status => {
  if (!status) return EMPTY_VALUE;
  const statusLower = status.toLowerCase();
  return STATUS_MAP[statusLower] || capitalize(status);
};

/**
 * Format billed status for display
 */
export const formatBilledStatus = status => {
  if (!status) return EMPTY_VALUE;
  const statusLower = status.toLowerCase();
  return BILLED_STATUS_MAP[statusLower] || capitalize(status);
};

/**
 * Format charge type for display
 */
export const formatChargeType = type => {
  if (!type) return EMPTY_VALUE;
  return CHARGE_TYPE_MAP[type] || type;
};

/**
 * Get profitability color based on value
 */
export const getProfitabilityColor = value => {
  if (value == null) return PROFITABILITY_COLORS.DEFAULT;
  if (value < PROFITABILITY_THRESHOLDS.NEGATIVE) return PROFITABILITY_COLORS.NEGATIVE;
  if (value <= PROFITABILITY_THRESHOLDS.LOW) return PROFITABILITY_COLORS.LOW;
  return PROFITABILITY_COLORS.GOOD;
};

/**
 * Get profitability badge class for inline badges
 */
export const getProfitabilityBadgeClass = value => {
  if (value >= 50) return 'bg-green-100 text-green-700';
  if (value >= 20) return 'bg-yellow-100 text-yellow-700';
  if (value >= 0) return 'bg-orange-100 text-orange-700';
  return 'bg-red-100 text-red-700';
};

/**
 * Get profitability icon based on value
 */
export const getProfitabilityIcon = value => {
  return value >= 0 ? 'mdi-trending-up' : 'mdi-trending-down';
};

/**
 * Get status color for chips/badges
 */
export const getStatusColor = status => {
  const statusLower = status?.toLowerCase();
  return STATUS_COLORS[statusLower] || 'grey-lighten-2';
};

/**
 * Get completion color for chips/badges
 */
export const getCompletionColor = status => {
  const statusLower = status?.toLowerCase();
  return COMPLETION_COLORS[statusLower] || 'grey';
};

/**
 * Format percentage value for display
 */
export const formatPercentage = value => {
  if (value == null) return EMPTY_VALUE;
  return `${value}%`;
};